import { jsx as l } from "react/jsx-runtime";
import { I as e } from "../icon-DNHpBTHs.mjs";
const s = {
  name: "close",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.864 4.864a.9.9 0 0 1 1.273 0L12 10.727l5.864-5.863a.9.9 0 0 1 1.272 1.272L13.273 12l5.863 5.864a.9.9 0 1 1-1.272 1.272L12 13.273l-5.863 5.863a.9.9 0 0 1-1.273-1.272L10.727 12 4.864 6.136a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["close"],
  category: "utility"
}, r = (o) => /* @__PURE__ */ l(e, { ...o, svg: s });
r.displayName = "IconClose";
export {
  r as IconClose
};
//# sourceMappingURL=close.es.js.map
